import React from 'react';
import styled from 'styled-components';
import { SectionNavbar } from '../section-navbar';
import { Festivals } from '../festivals';
import { Vendors } from '../vendors';
import { Performers } from '../performers';

const HomeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

const DeployDate = styled.div`
  margin-top: auto;
  padding: 1.5rem;
  text-align: center;
  font-size: 0.875rem;
  color: #9b9b9b;
`;

export default ({ ...props }) => {
  const sections = [
    {
      title: 'Festivals',
      component: <Festivals />,
    },
    {
      title: 'Vendors',
      component: <Vendors />,
    },
    {
      title: 'Performers',
      component: <Performers />,
    }
  ];

  const deployDate = process.env.REACT_APP_DEPLOY_DATE;
  const apiUrl = process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_BASE_API_URL_PROD
    : process.env.REACT_APP_BASE_API_URL_DEV;

  return (
    <HomeWrapper>
      <SectionNavbar navItems={sections} />
      {(deployDate || apiUrl) && (
        <DeployDate>
          {deployDate && <div>Deploy date: {deployDate}</div>}
          {apiUrl && <div>API URL: {apiUrl}</div>}
        </DeployDate>
      )}
    </HomeWrapper>
  );
}
